module.exports = __webpack_public_path__ + "img/ksj.34f93a89.png";